import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const TEXT_RESOURCE_CHANGED = gql`
  subscription textResourceChanged($id: Int) {
    textResourceChanged(id: $id) {
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
